import { Box, Container } from "@chakra-ui/react";

import MatrimonyNavbar from "src/pages/home/matrimonyNavbar";
import { Outlet } from "react-router-dom";

export default function MatrimonyLayout() {
    return (
        <Box minH="100vh" bg="#FBF7F4">
        <Box position="sticky" top={0} zIndex={50}>
            <MatrimonyNavbar isScrolled={true} activeSection="" />
        </Box>

        <Container
            maxW="7xl"
            py={{ base: 3, md: 5, xl: 6 }}
            px={{ base: 3, md: 6, xl: 8 }}
        >
            {/* Child routes render here */}
            <Outlet />
        </Container>
        </Box>
    );
}